import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonService } from '../services/common.service';
import { WorkflowActionModel } from '../../models/WorkflowActionModel';


@Component({
  selector: 'app-workflow-action',
  templateUrl: './workflow-action.component.html',
  styleUrls: ['./workflow-action.component.css']
})
export class WorkflowActionComponent implements OnInit {

  @Input() workflowUrl;
  @Output() workflowActionSelected = new EventEmitter<any>();
  @Output() workflowLoaded = new EventEmitter<any>();
  statusChangeWorkflowActions: WorkflowActionModel[] = [];
  editWorkflowActions: WorkflowActionModel[] = []; // such as for editing, we assume there will be only one item

  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
    this.getWorkflowActions();
  }

  selectWorkflowAction(action: any): void {
    this.workflowActionSelected.emit(action);
  }

  getWorkflowActions() {
    this.commonService.getWorkflowActions(this.workflowUrl).subscribe(result => {
      if (result) {
        this.statusChangeWorkflowActions = result.filter(r => r.isStatusChange || r.event == 'regenerateDocument');
        this.editWorkflowActions = result.filter(r => r.event == 'edit');
        this.workflowLoaded.emit(result);
      }
    });
  }

  getLabelFromEvent(event) {
    return event.charAt(0).toUpperCase() + event.slice(1).replace(/([a-z0-9])([A-Z])/g, '$1 $2');
  }
}
